import React from 'react';
import { Text, View } from '@react-pdf/renderer';

const ActivitySection = ({ text, order, subText, duration }: any) => {
  return (
    <View style={{
      marginTop: 15
    }}>
      <View style={{
          display: 'flex',
          flexDirection: 'row',
          alignItems: 'center',
          fontFamily: 'Helvetica-Bold',
        }}>
        <Text style={{
          color: 'rgb(101 163 13)',
        }}>Activité {order + 1} : {text}</Text>
        <Text style={{
          fontSize: 9,
          marginLeft: 5
        }}>(Durée : {duration} min)</Text>
      </View>
      {
        subText
        ? <Text style={{
          marginTop: 5,
        }}>{subText}</Text>
        : null
      }
    </View>
  )
}

export default ActivitySection
